import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { eq } from "drizzle-orm";
import { db } from "~/db";
import { user } from "~/db/schema";
import { auth } from "~/lib/better-auth/auth";

export const getDashboardIsSuperAdmin = createServerFn({ method: "GET" }).handler(
  async (): Promise<boolean> => {
    const request = getRequest();

    if (!request?.headers) {
      return false;
    }

    try {
      const userSession = await auth.api.getSession({
        headers: request.headers,
      });

      const userId = userSession?.user?.id;
      if (!userId) {
        return false;
      }

      const rows = await db
        .select({ isSuperAdmin: user.isSuperAdmin })
        .from(user)
        .where(eq(user.id, userId))
        .limit(1);

      const dbUser = rows[0];
      return dbUser?.isSuperAdmin === true;
    } catch {
      return false;
    }
  },
);
